/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImageUploadUrlResponse
 */
export interface ImageUploadUrlResponse {
    /**
     * 
     * @type {string}
     * @memberof ImageUploadUrlResponse
     */
    uploadUrl: string;
    /**
     * 
     * @type {string}
     * @memberof ImageUploadUrlResponse
     */
    imageUrl: string;
}

/**
 * Check if a given object implements the ImageUploadUrlResponse interface.
 */
// @ts-ignore
export function instanceOfImageUploadUrlResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "uploadUrl" in value;
    isInstance = isInstance && "imageUrl" in value;

    return isInstance;
}

// @ts-ignore
export function ImageUploadUrlResponseFromJSON(json: any): ImageUploadUrlResponse {
    return ImageUploadUrlResponseFromJSONTyped(json, false);
}

// @ts-ignore
export function ImageUploadUrlResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImageUploadUrlResponse {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uploadUrl': json['upload_url'],
        'imageUrl': json['image_url'],
    };
}

// @ts-ignore
export function ImageUploadUrlResponseToJSON(value?: ImageUploadUrlResponse | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'upload_url': value.uploadUrl,
        'image_url': value.imageUrl,
    };
}

